"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Direct() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: footnoteRef,
    isVisible: footnoteVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const departments = [{
    name: "Automotive Engineering",
    description: "Technical sales representation for Tier 1 and Tier 2 automotive suppliers, focusing on precision components and assembly systems.",
    email: "auto@metpropartners.com",
    phone: "+1 (555) 882-9001"
  }, {
    name: "Metal Fabrication",
    description: "Strategic market penetration for high-tolerance metal fabrication firms, connecting capabilities with industrial procurement leaders.",
    email: "fab@metpropartners.com",
    phone: "+1 (555) 882-9002"
  }, {
    name: "Industrial Safety",
    description: "Specialized sales efforts for safety-critical equipment, ensuring compliance and operational reliability for heavy industry.",
    email: "safety@metpropartners.com",
    phone: "+1 (555) 882-9003"
  }];
  return;
}